import React, { useState, useEffect, useRef } from "react";
import { getTelemetry, resetTelemetry } from "./Api.js";

const Telemetric = () => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null); 
    const [totalTime, setTotalTime] = useState(0);
    const [upgrade, setUpgrade] = useState(false);

    useEffect(() => {
        if (!window.Chart) {
            console.error("Chart.js não carregado. Adicione a CDN no index.html.");
            return;
        }
        getTelemetry().then(dataJson=> {
            buildChart(dataJson);
        });
        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, []);

    useEffect(() => {
        getTelemetry().then(dataJson=> {
            buildChart(dataJson);
        });
    }, [upgrade]);

    const resetChart = () => {
        resetTelemetry();
        setTotalTime(0);
        chartInstanceRef.current.destroy();
    }

    const buildChart = (dataJson) => {
        const agents = {};
        const tools = {};

        Object.keys(dataJson).forEach(key => {
            const value = dataJson[key];
            if (key.startsWith("agent#")) {
                agents[key.replace("agent#", "").trim()] = value;
            } else if (key.startsWith("tool#")) {
                tools[key.replace("tool#", "").trim()] = value;
            }
        });

        const labels = Array.from(new Set([...Object.keys(agents), ...Object.keys(tools)]));
        const agentsData = labels.map(label => agents[label] || 0); 
        const toolsData = labels.map(label => tools[label] || 0);
        setTotalTime(Math.round(100*Object.values(dataJson).reduce((acc, value) => acc + value, 0))/100);
        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: "Agentes",
                    data: agentsData,
                    backgroundColor: "rgba(54, 162, 235, 0.6)",
                    borderColor: "rgba(54, 162, 235, 1)",
                    borderWidth: 1,
                },
                {
                    label: "Ferramentas",
                    data: toolsData,
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    borderColor: "rgba(255, 99, 132, 1)",
                    borderWidth: 1,
                }
            ],
        };
     
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: true },
                title: {
                    display: true,
                    text: "Consumo de Tempo por Agentes e Ferramentas",
                },
            },
            scales: {
                x: {
                    stacked: false, 
                    ticks: { autoSkip: false, maxRotation: 30, minRotation: 30 },
                },
                y: {
                    stacked: false,
                    beginAtZero: true,
                },
            },
        };

        
        setTimeout(() => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }

            const ctx = chartRef.current.getContext("2d");
            chartInstanceRef.current = new window.Chart(ctx, {
                type: "bar",
                data: chartData,
                options: chartOptions
            });
        }, 100);
    }

    return (
        <div style={{ width: "80vw", height: "60vh", margin: "120px auto", position: "relative" }}>
            <h2>Tempo de espera médio por recurso <i style={{cursor: "pointer"}} className="fa fa-refresh" onClick={()=>setUpgrade(!upgrade)}/></h2>
            <canvas ref={chartRef} style={{ width: "100%", height: "100%" }}></canvas>
            <br/>
            <label>Tempo médio total do ciclo: </label> <b>{totalTime}</b> seg.
            <button style={{float: "right"}} onClick={()=>resetChart()}>Resetar valores</button>
        </div>
    );
};

export default Telemetric;
